export function getReviewsSectionTitle({
  hasReviews,
  hasTestimonials,
}: {
  hasReviews: boolean;
  hasTestimonials: boolean;
}): string {
  if (hasReviews && hasTestimonials) return 'Reviews & Testimonials';
  if (hasReviews) return 'Reviews';
  return 'Testimonials';
}
